import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiPlayCircle, FiActivity, FiLayers, FiCode, FiInfo, FiHelpCircle } from 'react-icons/fi';
import WorkflowStepper from '../components/Demo/WorkflowStepper';
import DataExplorer from '../components/Demo/DataExplorer';
import StateSimulator from '../components/Demo/StateSimulator';
import Overview from '../components/Demo/Overview';
import FAQ from '../components/Demo/FAQ';

export default function Demo() {
  return (
    <div className="space-y-16 pb-24 px-4 md:px-0 max-w-6xl mx-auto">
      {/* Hero Heading */}
      <section className="pt-4">
        <div className="flex flex-col md:flex-row md:items-center gap-6 mb-4">
          <div className="p-4 bg-quest-500/20 rounded-3xl border border-quest-500/30 w-fit">
            <SafeIcon icon={FiPlayCircle} className="text-4xl text-quest-500 shadow-glow-green" />
          </div>
          <div>
            <h1 className="text-4xl md:text-6xl font-black tracking-tighter text-white">
              DEMO / <span className="text-quest-500">HOW IT WORKS</span>
            </h1>
            <p className="text-gray-500 font-mono text-sm md:text-lg mt-2 uppercase tracking-widest">
              Operational Blueprint v1.0.4 // Autonomous Learning System
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Overview / What it does */}
      <section className="space-y-8">
        <div className="flex items-center gap-3 border-b border-navy-800 pb-4">
          <SafeIcon icon={FiInfo} className="text-trophy-500 text-2xl" />
          <h2 className="text-2xl font-bold uppercase tracking-tight text-white">Overview / What it does</h2>
        </div>
        <Overview />
      </section>

      {/* Section 2: Demo / How It Works -> Try this flow */}
      <section className="space-y-8">
        <div className="flex items-center gap-3 border-b border-navy-800 pb-4">
          <SafeIcon icon={FiActivity} className="text-neon-pink text-2xl" />
          <h2 className="text-2xl font-bold uppercase tracking-tight text-white">Try this flow</h2>
        </div>
        <div className="p-1 bg-navy-800 rounded-3xl">
          <WorkflowStepper />
        </div>
        <div className="mt-4 p-4 bg-navy-900/30 rounded-xl border border-navy-800 italic text-sm text-gray-500 text-center">
          * Interactive flow: Click the step markers or arrows to simulate the user journey *
        </div>
      </section>

      {/* Section 3: Sample Data */}
      <section className="space-y-8">
        <div className="flex items-center gap-3 border-b border-navy-800 pb-4">
          <SafeIcon icon={FiLayers} className="text-neon-blue text-2xl" />
          <h2 className="text-2xl font-bold uppercase tracking-tight text-white">Sample Data</h2>
        </div>
        <DataExplorer />
      </section>

      {/* Section 4: Simulated States */}
      <section className="space-y-8">
        <div className="flex items-center gap-3 border-b border-navy-800 pb-4">
          <SafeIcon icon={FiCode} className="text-quest-500 text-2xl" />
          <h2 className="text-2xl font-bold uppercase tracking-tight text-white">Simulated States</h2>
        </div>
        <StateSimulator />
      </section>

      {/* Section 5: FAQ */}
      <section className="space-y-8">
        <div className="flex items-center gap-3 border-b border-navy-800 pb-4">
          <SafeIcon icon={FiHelpCircle} className="text-gray-400 text-2xl" />
          <h2 className="text-2xl font-bold uppercase tracking-tight text-white">FAQ</h2>
        </div>
        <FAQ />
      </section>

      {/* Footer Credit - EXACT MATCH REQUIRED */}
      <footer className="pt-20 pb-8 text-center border-t border-navy-900">
        <div className="inline-flex flex-col items-center gap-2">
          <p className="text-xs text-navy-500 font-mono tracking-widest uppercase opacity-60">
            System Origin: SkillQuest Core v1.0
          </p>
          <p className="text-sm text-gray-400 font-medium">
            Made by <span className="text-quest-400">LingLink AI</span> and <span className="text-trophy-400">DigLab AI</span>
          </p>
        </div>
      </footer>
    </div>
  );
}